import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ConexaoAviso } from '@/components/state/ConexaoAviso'

/**
 * O portal do paciente fora da sessão.
 *
 * Fora da série a superfície é a mesma do consultório: é uma tela de
 * consulta, com listas e datas. Só a sala em si troca para os tokens calmos,
 * e ela não mora aqui dentro.
 */
export const Route = createFileRoute('/_portal')({
  component: function PortalLayout() {
    return (
      <div data-surface="consultorio" className="h-full">
        <Outlet />
        <ConexaoAviso />
      </div>
    )
  },
})
